import { useTranslation } from "react-i18next";
import { Image, View } from "react-native";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { Button, Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import styled from "styled-components/native";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { useEffect, useState } from "react";
import EmptyImagePreview from "@components/molecules/GalleryView/utils/EmptyImage/EmptyImagePreview";
import { getShapeValue } from "@components/molecules/GalleryView/utils/EmptyImage/utils";
import React from "react";
import LineViewContainer from "@scenes/requests/utils/LineView";
import { Diamond } from "@src/types/DiamondDetail";
import { navigateToHistory } from "@redux/slices/navigationHistorySlice";
import { useDispatch, useSelector } from "react-redux";
import { NavigationHistoryState } from "@components/molecules/Breadcrumbs/utils";
import { CommonActions, useNavigation } from "@react-navigation/native";
import {
  getSearchIndexByProductType,
  getSearchIndexOfMatchingStone,
  popToScreen,
  refreshSavedSearchForEntry,
} from "../utils/utils";
import Popup from "@components/molecules/PopUp";
import { messageType } from "@components/molecules/PopUp/types";
import {
  setBuilderProduct,
  setDisableJewelrySettingStoneLinkage,
} from "@redux/slices/appStateSlice";
import Routes from "@navigations/Routes";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";
import {
  setAuxPayloadData,
  setFiltersPayload,
  setPayloadData,
  useSearchFiltersAuxPayload,
} from "@redux/slices/searchFilters";
import { useJewelryConfiguratorState } from "@scenes/configurator/JewelryConfigurator/Context/JewelryConfiguratorContext";
import {
  AddJewelryOptions,
  getProductPrefix,
  ProductCategory,
} from "@utils/constants";
import { useSearchFiltersSlice } from "@redux/slices/searchFilters";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { isPair } from "@utils/product/productValidators";
import { CustomisationKey } from "@scenes/pdp/types";
import { CustomtOption, PdpSections } from "@utils/customization";
import { useFilteredSection } from "../../../hooks/useFilteredOptions";
import { useGetPdpSectionLayout } from "../../../hooks/useGetSectionLayout";
import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";
import {
  stripJewelryLinkageFromPayload,
  toSettingSearchFirstFlowParams,
} from "@scenes/searchResults/utils/stripJewelryLinkageFromPayload";

type ReviewPageCardProps = {
  type?: "stone" | "setting" | "matchingStone";
  itemDetail?: Diamond;
  setShowModal?: any;
  toggleGalleryItem: (type?: "stone" | "matchingStone" | "setting") => void;
  matchingPair?: boolean;
  fromRequest?: boolean;
  selectedType?: string;
  isFirstBreadcrumbStoneDetailPage?: boolean;
  isFirstBreadcrumbJewelryDetailPage?: boolean;
  startFromSetting?: boolean;
  startFromStone?: boolean;
};

const ReviewPageCard = ({
  type,
  itemDetail,
  setShowModal,
  toggleGalleryItem,
  matchingPair,
  fromRequest,
  selectedType,
  isFirstBreadcrumbStoneDetailPage = false,
  isFirstBreadcrumbJewelryDetailPage = false,
  startFromSetting = false,
  startFromStone = false,
}: ReviewPageCardProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const { theme, typography } = useScreenOptionsHooks();
  const [imageError, setImageError] = useState(false);
  const handleError = () => {
    setImageError(true);
  };
  const [showPopUp, setShowPopUp] = useState(false);
  const [customOptions, setCustomOptions] = useState<CustomtOption[]>([]);
  const { history } = useSelector(
    (state: any) => state.navigationHistory as NavigationHistoryState
  );
  const { min_max_Options } = useSearchFiltersSlice();
  const userInfo = useUserInfo();
  const { enableJewelryBuilder } = useOrgSettingsSlice();
  const modifyShapeSupportForBuilder =
    min_max_Options?.supported_shapes?.length > 0 &&
    userInfo.user.feature_settings?.allow_search_modify_in_builder &&
    enableJewelryBuilder &&
    itemDetail?.type === ProductCategory.JEWELRY &&
    history.length > 2;

  let auxPayload = useSearchFiltersAuxPayload();

  const { clearRouteHistory, addRouteToHistory } = useNavigationHistory();

  const {
    itemDetail: mItemDetail,
    stoneItemDetail: mStoneItemDetail,
    setStoneItemDetail,
    clearItemDetail,
    jcSelectedOption,
    setItemDetail,
  } = useJewelryConfiguratorState();

  const handleNavigate = () => {
    setShowPopUp(true);
  };

  const jumpInStoneToSettingFlow = () => {
    const searchScreenRoute = theme.isMobile
      ? Routes.SearchResultScreen
      : Routes.FilterSplitScreen;

    const filtered = history.filter(
      (item) =>
        [searchScreenRoute, Routes.PDPScreen, Routes.FindMatchScreen].includes(
          item.screen
        ) && item.params.productType !== "jewelry"
    );

    const jewelryFilterSplitScreen = history.filter(
      (item) =>
        [searchScreenRoute].includes(item.screen) &&
        item.params.productType === "jewelry"
    );

    const jewelryRouteParams = {
      ...jewelryFilterSplitScreen?.[0]?.params,
      filterSplitStep: 2,
    };
    jewelryRouteParams.enterSecondFlow = true;
    jewelryRouteParams.searchForRing =
      mStoneItemDetail?.jewelry_style?.includes("Engagement Ring")
        ? true
        : false;
    jewelryRouteParams.searchForPendant =
      mStoneItemDetail?.jewelry_style?.includes("Pendant") ? true : false;
    const saved_search = {
      jewelry_styles: [
        mStoneItemDetail?.jewelry_style?.includes("Earring")
          ? "earring"
          : mStoneItemDetail?.jewelry_style?.includes("Engagement Ring")
          ? AddJewelryOptions.ENGAGEMENT_RING
          : AddJewelryOptions.PENDANT,
      ],
      itemType: 2,
      sub_type: null,
      preference: [],
      vdb_setting: "true",
      stock_item_ids: [mItemDetail?.id],
      is_center_size_selected: "true",
    };
    jewelryRouteParams.saved_search = JSON.stringify(saved_search);

    const jewelryRoute = {
      name: searchScreenRoute,
      params: jewelryRouteParams,
    };

    const sectionName = filtered?.[0]?.params?.sectionName;
    const productType = filtered?.[0]?.params?.productType;

    const cleanedPayload = {
      ...auxPayload,
      [sectionName]: Object.fromEntries(
        Object.entries(auxPayload[sectionName]).filter(
          ([key]) =>
            !["shapes", "size_from", "size_to", "stock_item_ids"].includes(key)
        )
      ),
    };

    const payload = cleanedPayload[sectionName];

    if (Object.keys(payload).length > 0) {
      dispatch(
        setFiltersPayload({
          sectionName: sectionName,
          data: payload,
        })
      );

      dispatch(
        setPayloadData({
          productType: productType,
          data: { [sectionName]: payload },
        })
      );
    }

    dispatch(setAuxPayloadData(cleanedPayload));

    clearRouteHistory();
    dispatch(setBuilderProduct(ProductCategory.JEWELRY));

    const routes = filtered.map((_item) => {
      const { screen, params } = _item;

      let newParams = { ...params, enterSecondFlow: false };

      if (screen === searchScreenRoute) {
        delete newParams.saved_search;
      }

      if (screen === Routes.FindMatchScreen) {
        newParams = { ...newParams, showPairButton: true };
      }

      return {
        name: screen,
        params: newParams,
      };
    });

    // add explore screen for mobile
    const exploreScreenRoute = {
      name: Routes.Explore,
      params: {},
    };

    // add filter screen for mobile
    const filterScreenRoute = {
      name: Routes.FilterScreen,
      params: {
        productType: productType,
        productPrefix: getProductPrefix(productType),
        sectionName: sectionName,
        fromResultScreen: false,
      },
    };

    const mobileRoutes = [exploreScreenRoute, filterScreenRoute];

    routes.push(jewelryRoute);
    let finalRoutes =
      theme.isMobile || theme.isTablet ? [...mobileRoutes, ...routes] : routes;

    // reset item detail objects
    setStoneItemDetail(mItemDetail);
    clearItemDetail(true);

    navigation.dispatch(
      CommonActions.reset({
        index: finalRoutes.length - 1,
        routes: finalRoutes,
      })
    );

    filtered.forEach((_item) => {
      const screenRoute = _item.screen;
      const params = {
        ..._item.params,
        enterSecondFlow: _item?.params?.productType === "jewelry",
        ...(screenRoute === Routes.FindMatchScreen && { showPairButton: true }),
      };

      const mRoute = {
        name: screenRoute,
        params,
      };

      addRouteToHistory(mRoute);
    });

    // After all routes added, push the jewelry route
    addRouteToHistory(jewelryRoute);

    setShowPopUp(false);
  };

  const jumpInSettingToStoneFlow = () => {
    const searchScreenRoute = theme.isMobile
      ? Routes.SearchResultScreen
      : Routes.FilterSplitScreen;

    const mStoneProductType = history[0]?.params?.productType;

    const filtered = history.filter(
      (item) =>
        [searchScreenRoute, Routes.PDPScreen, Routes.FindMatchScreen].includes(
          item.screen
        ) && item.params.productType === "jewelry"
    );

    const stoneFilterSplitScreen = history.filter(
      (item) =>
        [searchScreenRoute].includes(item.screen) &&
        item.params.productType !== "jewelry"
    );

    const stoneRouteParams = {
      ...stoneFilterSplitScreen?.[0]?.params,
      filterSplitStep: 2,
    };

    stoneRouteParams.enterSecondFlow = true;
    const saved_search = {
      shapes: [jcSelectedOption.current?.option_value?.supported_shapes],
      size_from: jcSelectedOption.current?.option_value?.supported_carat_from,
      size_to: jcSelectedOption.current?.option_value?.supported_carat_to,
      itemType: 1,
      sub_type: null,
      preference: [],
      vdb_setting: "true",
      stock_item_ids: [mStoneItemDetail?.id],
    };
    stoneRouteParams.saved_search = JSON.stringify(saved_search);

    const stoneRoute = {
      name: searchScreenRoute,
      params: stoneRouteParams,
    };

    const sectionName = filtered?.[0]?.params?.sectionName;
    const productType = filtered?.[0]?.params?.productType;

    const cleanedPayload = {
      ...auxPayload,
      ...(sectionName
        ? {
            [sectionName]: stripJewelryLinkageFromPayload(
              auxPayload[sectionName] || {}
            ),
          }
        : {}),
    };

    const payload = sectionName ? cleanedPayload[sectionName] : {};

    if (Object.keys(payload).length > 0) {
      dispatch(
        setFiltersPayload({
          sectionName: sectionName,
          data: payload,
        })
      );

      dispatch(
        setPayloadData({
          productType: productType,
          data: { [sectionName]: payload },
        })
      );
    }

    dispatch(setAuxPayloadData(cleanedPayload));

    clearRouteHistory();
    dispatch(setBuilderProduct(mStoneProductType));

    const routes = filtered.map((_item) => {
      const { screen, params } = _item;

      let newParams =
        screen === searchScreenRoute
          ? toSettingSearchFirstFlowParams(params)
          : { ...params, enterSecondFlow: false };

      if (screen === Routes.PDPScreen) {
        newParams.productID = mItemDetail?.id;
      }

      return {
        name: screen,
        params: newParams,
      };
    });

    // add explore screen for mobile
    const exploreScreenRoute = {
      name: Routes.Explore,
      params: {},
    };

    // add filter screen for mobile
    const filterScreenRoute = {
      name: Routes.FilterScreen,
      params: {
        productType: productType,
        productPrefix: getProductPrefix(productType),
        sectionName: sectionName,
        fromResultScreen: false,
      },
    };

    const mobileRoutes = [exploreScreenRoute, filterScreenRoute];

    routes.push(stoneRoute);
    let finalRoutes =
      theme.isMobile || theme.isTablet ? [...mobileRoutes, ...routes] : routes;

    // reset item detail objects
    setStoneItemDetail(mItemDetail);
    clearItemDetail(false);

    navigation.dispatch(
      CommonActions.reset({
        index: finalRoutes.length - 1,
        routes: finalRoutes,
      })
    );

    filtered.forEach((_item) => {
      const screenRoute = _item.screen;
      const params = {
        ...(screenRoute === searchScreenRoute
          ? toSettingSearchFirstFlowParams(_item.params)
          : {
              ..._item.params,
              enterSecondFlow: _item?.params?.productType !== "jewelry",
            }),
        ...(screenRoute === Routes.FindMatchScreen && { showPairButton: true }),
        ...(screenRoute === Routes.PDPScreen && {
          productID: mItemDetail?.id,
        }),
      };

      const mRoute = {
        name: screenRoute,
        params,
      };

      addRouteToHistory(mRoute);
    });

    // After all routes added, push the stone route
    addRouteToHistory(stoneRoute);

    setShowPopUp(false);
  };

  const jumpInSettingToStoneFlowWithMatchPair = () => {
    const searchScreenRoute = theme.isMobile
      ? Routes.SearchResultScreen
      : Routes.FilterSplitScreen;

    const mStoneProductType = history[0]?.params?.productType;

    const filtered = history.filter(
      (item) =>
        [searchScreenRoute, Routes.PDPScreen, Routes.FindMatchScreen].includes(
          item.screen
        ) && item.params.productType === "jewelry"
    );

    const stoneFilterSplitScreen = history.filter(
      (item) =>
        [searchScreenRoute].includes(item.screen) &&
        item.params.productType !== "jewelry"
    );

    const stoneRouteParams = {
      ...stoneFilterSplitScreen?.[0]?.params,
      filterSplitStep: 2,
    };

    stoneRouteParams.enterSecondFlow = true;
    const saved_search = {
      shapes: [jcSelectedOption.current?.option_value?.supported_shapes],
      size_from: jcSelectedOption.current?.option_value?.supported_carat_from,
      size_to: jcSelectedOption.current?.option_value?.supported_carat_to,
      itemType: 1,
      sub_type: null,
      preference: [],
      vdb_setting: "true",
      stock_item_ids: [mStoneItemDetail?.id],
    };
    stoneRouteParams.saved_search = JSON.stringify(saved_search);

    const stoneSearchResultRoute = {
      name: searchScreenRoute,
      params: stoneRouteParams,
    };

    // add PDP screen
    const stonePDPScreen = history.filter(
      (item) =>
        [Routes.PDPScreen].includes(item.screen) &&
        item.params.productType !== "jewelry"
    );

    const stonePDPRouteParams = {
      ...stonePDPScreen?.[0]?.params,
      enterSecondFlow: true,
    };

    const stonePdpRoute = {
      name: Routes.PDPScreen,
      params: stonePDPRouteParams,
    };

    // add Match Pair screen
    const matchPairScreen = history.filter(
      (item) =>
        [Routes.FindMatchScreen].includes(item.screen) &&
        item.params.productType !== "jewelry"
    );

    const matchPairRouteParams = {
      ...matchPairScreen?.[0]?.params,
      enterSecondFlow: true,
      showPairButton: true,
    };

    const matchPairRoute = {
      name: Routes.FindMatchScreen,
      params: matchPairRouteParams,
    };

    const sectionName = filtered?.[0]?.params?.sectionName;
    const productType = filtered?.[0]?.params?.productType;

    const cleanedPayload = {
      ...auxPayload,
      ...(sectionName
        ? {
            [sectionName]: stripJewelryLinkageFromPayload(
              auxPayload[sectionName] || {}
            ),
          }
        : {}),
    };

    const payload = sectionName ? cleanedPayload[sectionName] : {};

    if (Object.keys(payload).length > 0) {
      dispatch(
        setFiltersPayload({
          sectionName: sectionName,
          data: payload,
        })
      );

      dispatch(
        setPayloadData({
          productType: productType,
          data: { [sectionName]: payload },
        })
      );
    }

    dispatch(setAuxPayloadData(cleanedPayload));

    clearRouteHistory();
    dispatch(setBuilderProduct(mStoneProductType));

    const routes = filtered.map((_item) => {
      const { screen, params } = _item;

      const newParams =
        screen === searchScreenRoute
          ? toSettingSearchFirstFlowParams(params)
          : { ...params, enterSecondFlow: false };

      return {
        name: screen,
        params: newParams,
      };
    });

    // add explore screen for mobile
    const exploreScreenRoute = {
      name: Routes.Explore,
      params: {},
    };

    // add filter screen for mobile
    const filterScreenRoute = {
      name: Routes.FilterScreen,
      params: {
        productType: productType,
        productPrefix: getProductPrefix(productType),
        sectionName: sectionName,
        fromResultScreen: false,
      },
    };

    const mobileRoutes = [exploreScreenRoute, filterScreenRoute];

    routes.push(stoneSearchResultRoute);
    routes.push(stonePdpRoute);
    routes.push(matchPairRoute);

    let finalRoutes =
      theme.isMobile || theme.isTablet ? [...mobileRoutes, ...routes] : routes;

    // reset item detail objects
    setStoneItemDetail(mItemDetail);
    setItemDetail(mStoneItemDetail);

    navigation.dispatch(
      CommonActions.reset({
        index: finalRoutes.length - 1,
        routes: finalRoutes,
      })
    );

    filtered.forEach((_item) => {
      const screenRoute = _item.screen;
      const params =
        screenRoute === searchScreenRoute
          ? toSettingSearchFirstFlowParams(_item.params)
          : {
              ..._item.params,
              enterSecondFlow: _item?.params?.productType !== "jewelry",
            };

      const mRoute = {
        name: screenRoute,
        params,
      };

      addRouteToHistory(mRoute);
    });

    // After all routes added, push the stone route
    addRouteToHistory(stoneSearchResultRoute);
    addRouteToHistory(stonePdpRoute);
    addRouteToHistory(matchPairRoute);

    setShowPopUp(false);
  };

  const stoneType = isPair(itemDetail)
    ? SearchFilterTypeEnum.PAIRS
    : SearchFilterTypeEnum.SINGLE_STONES;

  const sectionLayout = useGetPdpSectionLayout(
    PdpSections.SUMMARY,
    itemDetail?.type,
    stoneType
  );

  const filteredSections = useFilteredSection(
    theme,
    userInfo?.getPriceMode(),
    sectionLayout
  );

  useEffect(() => {
    setCustomOptions(filteredSections);
  }, [filteredSections]);

  const handleConfirmNavigation = () => {
    dispatch(
      setDisableJewelrySettingStoneLinkage(
        type === "stone" || type === "matchingStone"
      )
    );

    if (startFromStone) {
      if (type === "stone") {
        jumpInSettingToStoneFlow();
      } else if (type === "matchingStone") {
        jumpInSettingToStoneFlowWithMatchPair();
      }
    } else if (type === "setting" && startFromSetting) {
      jumpInStoneToSettingFlow();
    } else {
      changeWhenFlowNotBreak();
    }
  };

  const changeWhenFlowNotBreak = () => {
    if (type === "stone" || type === "matchingStone") {
      const searchScreenRoute = theme.isMobile
        ? Routes.SearchResultScreen
        : Routes.FilterSplitScreen;
      const jewelrySearch = history.find(
        (item) =>
          [searchScreenRoute].includes(item.screen) &&
          (item.params?.productType === ProductCategory.JEWELRY ||
            item.params?.productType === ProductCategory.LABGROWN_JEWELRY)
      );
      const jewelrySectionName = jewelrySearch?.params?.sectionName;
      const jewelryProductType = jewelrySearch?.params?.productType;

      if (jewelrySectionName && auxPayload?.[jewelrySectionName]) {
        const cleanedSection = stripJewelryLinkageFromPayload(
          auxPayload[jewelrySectionName]
        );
        const cleanedPayload = {
          ...auxPayload,
          [jewelrySectionName]: cleanedSection,
        };

        dispatch(
          setFiltersPayload({
            sectionName: jewelrySectionName,
            data: cleanedSection,
          })
        );
        dispatch(
          setPayloadData({
            productType: jewelryProductType,
            data: { [jewelrySectionName]: cleanedSection },
          })
        );
        dispatch(setAuxPayloadData(cleanedPayload));
      }
    }

    const getTargetIndex = () => {
      if (matchingPair) return getSearchIndexOfMatchingStone(history);
      return getSearchIndexByProductType(history, itemDetail?.type);
    };

    const index = getTargetIndex();

    if (index === null) {
      setShowPopUp(false);
      return;
    }

    dispatch(navigateToHistory(index));
    const targetState = refreshSavedSearchForEntry(history[index], auxPayload);
    if (targetState.params?.productType) {
      dispatch(setBuilderProduct(targetState.params?.productType));
    }

    const historyWithLiveFilters = history.map((item, historyIndex) =>
      historyIndex === index ? targetState : item
    );

    popToScreen(
      navigation,
      historyWithLiveFilters,
      targetState.screen,
      targetState.params?.productType,
      theme,
      modifyShapeSupportForBuilder,
      true
    );
    setShowPopUp(false);
  };

  const handleCancelNavigation = () => {
    setShowPopUp(false);
  };

  const showChangeButton =
    !fromRequest &&
    (((type === "stone" || type === "matchingStone") &&
      !isFirstBreadcrumbStoneDetailPage) ||
      (type === "setting" && !isFirstBreadcrumbJewelryDetailPage));

  const getFilterDetailData = (searchText: string): any => {
    const filteredArray = customOptions.filter(
      (item) => item.name === searchText
    );

    return filteredArray;
  };

  const objStockNumber = getFilterDetailData(CustomisationKey.stock_no);

  return (
    <>
      <Overlay>
        <InfoContainer>
          <VDBText type={typography["H3-R"]} color={theme["core-06"]}>
            {type === "matchingStone"
              ? t("reviewPage.matchingStone.details.text")
              : type === "stone"
              ? t("reviewPage.stone.details.text")
              : t("reviewPage.setting.details.text")}
          </VDBText>
          {objStockNumber && objStockNumber?.length !== 0 && (
            <>
              <Spacer size={SpaceType.ExtraSmall} />
              <StockContainer>
                <VDBText type={typography["Body-R"]} color={theme["core-06"]}>
                  {type === "stone"
                    ? t("reviewPage.stone.details.stock.text")
                    : t("reviewPage.setting.details.stock.text")}
                </VDBText>
                <Spacer size={SpaceType.ExtraSmall} />
                <VDBText type={typography["Body-R"]} color={theme["core-05"]}>
                  {itemDetail?.stock_num}
                </VDBText>
              </StockContainer>
            </>
          )}
          <Spacer size={SpaceType.ExtraSmall} />
          <TextContainer>
            <VDBText type={typography["H2-M"]} color={theme["core-05"]}>
              {itemDetail?.short_title}
            </VDBText>
          </TextContainer>
          <Spacer size={SpaceType.Double} />
          <ButtonsContainer>
            {showChangeButton && (
              <Button
                maxWidth={87}
                category={ButtonCategory.jewelry}
                type={ButtonType.primary}
                title={
                  type === "stone"
                    ? t("reviewPage.stone.details.button.change.text")
                    : t("reviewPage.setting.details.button.change.text")
                }
                onPress={() => handleNavigate()}
              />
            )}
            {(type === "stone" || type === "matchingStone") && (
              <>
                {showChangeButton && <Spacer size={SpaceType.Basic} />}
                <Button
                  maxWidth={67}
                  category={ButtonCategory.jewelry}
                  type={ButtonType.primary}
                  title={t("reviewPage.stone.details.button.View.text")}
                  onPress={() => {
                    setShowModal(true);
                  }}
                />
              </>
            )}
          </ButtonsContainer>
        </InfoContainer>
        <ImageContainer onPress={() => toggleGalleryItem(type)}>
          {!imageError ? (
            <Image
              resizeMode={userInfo.disableImageZoom() ? "contain" : "cover"}
              source={{ uri: itemDetail?.image_url }}
              onError={handleError}
              style={[
                {
                  width: theme.isMobile ? 64 : 80,
                  height: theme.isMobile ? 64 : 80,
                  borderRadius: 8,
                  borderWidth: selectedType === itemDetail?.id ? 1 : 0,
                  borderColor: theme["core-05"],
                },
              ]}
            />
          ) : (
            <View
              style={[
                {
                  width: theme.isMobile ? 64 : 80,
                  height: theme.isMobile ? 64 : 80,
                  borderRadius: 8,
                  borderWidth: selectedType === itemDetail?.id ? 1 : 0,
                  borderColor: theme["core-05"],
                },
              ]}
            >
              <EmptyImagePreview
                shape={type === "stone" ? getShapeValue(itemDetail) : undefined}
                size={40}
                isPair={isPair(itemDetail) ?? false}
              />
            </View>
          )}
        </ImageContainer>
      </Overlay>
      {showPopUp && (
        <Popup
          type={messageType.Generic}
          buttons={[
            {
              type: ButtonType.primary,
              title: t("reviewPage.stone.details.popUp.buttons.yes.text"),
              onPressAction: handleConfirmNavigation,
              category: ButtonCategory.default,
            },
            {
              type: ButtonType.secondary,
              title: t("reviewPage.stone.details.popUp.buttons.cancel.text"),
              onPressAction: handleCancelNavigation,
            },
          ]}
          HtmlSource={{
            html: t("reviewPage.stone.details.popUp.title.text"),
          }}
          styleKey="Body-R"
        />
      )}
      <LineViewContainer background={"core-03"} />
    </>
  );
};

export default ReviewPageCard;

const Overlay = styled.View`
  flex-direction: row;
  justify-content: space-between;
  border-top-left-radius: ${SpaceType.Basic}px;
  border-top-right-radius: ${SpaceType.Basic}px;
  padding: ${SpaceType.Double}px;
`;
const InfoContainer = styled.View`
  flex: 1;
`;

const StockContainer = styled.View`
  flex-direction: row;
`;

const ButtonsContainer = styled.View`
  flex-direction: row;
`;
const ImageContainer = styled.TouchableOpacity`
  flex-direction: row;
`;
const TextContainer = styled.View`
  max-width: 90%;
`;
